<template>
<no-ssr>
  <div class="page-footer" :style="{ bottom: bottom + 'px' }">
    <Page :total="pageInfo.total"
      :current="pageInfo.pageNo"
      :pageSize="pageInfo.pageSize"
      show-sizer show-total
      @on-change="currentChange"
      @on-page-size-change="pageSizeChange"
      :pageSizeOpts="pageSizeOpts"
      show-elevator prev-text="上一页" next-text="下一页"/>
  </div>
  </no-ssr>
</template>
<script>
export default {
  name: "my-page",
  props: {
    init: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Number,
      default: 17
    }
  },
  data() {
    return {
      pageInfo: {
        total: 0,
        pageSize: 10,
        pageNo: 1
      },
      pageSizeOpts:[10,20,30,40,50,100]
    }
  },
  methods: {
    currentChange(val) {
      this.pageInfo.pageNo = val
      this.$emit("reload", this.pageInfo)
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val
      this.$emit("reload", this.pageInfo)
    },
    getPageInfo() {
      return this.pageInfo
    },
    resetPageNo() {
      this.pageInfo.pageNo = 1
    },
    setTotal(total) {
      this.pageInfo.total = total
    }
  },
  mounted () {
    if (this.init) {
      this.$emit("reload", this.pageInfo)
    }
  }
}
</script>
